<template>
  <v-dialog persistent :value="show" max-width="1000">
    <v-card>
      <button style="width: 1px; height: 1px; display: none"></button>
      <div class="text-xs-right">
        <v-btn name="close" small flat fab @click="onClose">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-layout row>
        <v-card-text>
          <div class="list-categories pb-3">
            <!-- <draggable :list="categorylist" class="dragArea" @change="checkMove">
            
          </draggable>-->
            <h1 class="mt-0">{{ $t('Category') }}</h1>
            <div>
              <div
                class="category"
                v-for="(category, index) in categorylist"
                :key="'category_' + index"
              >
                <ecommerce-category-edit
                  :categorylist="categorylist"
                  v-model="categorylist[index]"
                  :prefix="prefix"
                  @selectCat="selectCat"
                  @onDelete="onDeleteCategory(index, $event)"
                >
                  <template slot="move">
                    <move-vertical
                      :index="index"
                      :max="categorylist.length"
                      @onMove="onMove(index, $event)"
                      style="
                        width: 20px;
                        min-width: 20px;
                        display: inline-block;
                        float: left;
                        margin-right: 10px;
                      "
                    >
                      <div></div>
                    </move-vertical>
                  </template>
                </ecommerce-category-edit>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-text v-if="selectedCat">
          <div class="list-categories pb-3">
            <!-- <draggable :list="categorylist" class="dragArea" @change="checkMove">
            
          </draggable>-->
            <h1 class="mt-0">{{ $t('Sub Category') }}</h1>
            <div>
              <div
                class="category"
                v-for="(category, index) in subcategoryList"
                :key="'category_' + index"
              >
                <ecommerce-sub-category-edit
                  :categoryid="selectedCat"
                  :categorylist="subcategoryList"
                  v-model="subcategoryList[index]"
                  :prefix="prefix"
                  @onDelete="onDeleteCategory(index, $event)"
                >
                  <template slot="move">
                    <move-vertical
                      :index="index"
                      :max="subcategoryList.length"
                      @onMove="onMoveSubCat(index, $event)"
                      style="
                        width: 20px;
                        min-width: 20px;
                        display: inline-block;
                        float: left;
                        margin-right: 10px;
                      "
                    >
                      <div></div>
                    </move-vertical>
                  </template>
                </ecommerce-sub-category-edit>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import MoveVertical from '@/components/elements/MoveVertical'
import ecommerceCategoryEditKFC from './ecommerce-category-edit-kfc'
import ecommerceSubCategoryEditKFC from './ecommerce-sub-category-edit-kfc'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import ecommerceSubCategoryEdit from './ecommerce-sub-category-edit'
import api from '@/api'
import draggable from 'vuedraggable'

export default {
  props: ['value', 'show', 'prefix', 'categoryid'],
  computed: {
    categoryname() {
      return this.categorylist.map((v) => v.name)
    },
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    subcategoryList() {
      let category = this.categorylist.find((cate) => cate.id == this.selectedCat)
      if (category) {
        return category.subcategories
      } else {
        return null
      }
    }
  },
  data: function () {
    return {
      categorylist: this.value,
      currentCategory: null,
      currentSubCategory: null,
      selectedCat: null,
      newCategory: {
        name: null
      },
      newSubCategory: {
        name: null
      },
      isLoading: false,
      newSubCategory: {
        name: null
      },
      showEdit: false,
      isAdd: false,
      isAddSub: false
    }
  },
  mounted: function () {},
  components: {
    'ecommerce-sub-category-edit': ecommerceSubCategoryEditKFC,
    'ecommerce-category-edit': ecommerceCategoryEditKFC,
    draggable,
    PulseLoader,
    MoveVertical
    // 'ecommerce-sub-category-edit' : ecommerceSubCategoryEdit
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onMove(index, direction) {
      var vm = this
      if (direction == 'up') {
        vm.categorylist.splice(index, 0, vm.categorylist.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        vm.categorylist.splice(index, 0, vm.categorylist.splice(index + 1, 1)[0])
      }
      this.checkMove()
    },
    onMoveSubCat(index, direction) {
      var vm = this
      let temp = vm.subcategoryList
      if (direction == 'up') {
        temp.splice(index, 0, temp.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        temp.splice(index, 0, temp.splice(index + 1, 1)[0])
      }
      this.checkSubMove(temp)
    },
    onAddNew: function () {
      var vm = this
      vm.isAdd = true
      vm.$nextTick(function () {
        vm.$refs.newCategory.focus()
      })
    },
    onAddSubNew: function () {
      var vm = this
      vm.isAddSub = true
      vm.$nextTick(function () {
        vm.$refs.newSubCategory.focus()
      })
    },
    close: function () {
      let vm = this
      vm.showEdit = false
      vm.nextTick(function () {
        // vm.$emit('input',vm.product)
      })
    },
    selectCat(id) {
      this.selectedCat = id
    },
    checkMove: function (e) {
      // e.newIndex
      // e.oldIndex
      let vm = this
      let input = []
      input = vm.categorylist.map((el, index) => {
        return { id: el.id, priority: index }
      })

      api.putprioritycategoriesKFC({ input, pageid: this.pageid }, function (error, response) {
        if (error) {
          console.error(error)
          vm.isLoading = false
          return
        }
      })

      vm.$emit('input', vm.categorylist)
    },
    checkSubMove: function (temp) {
      // e.newIndex
      // e.oldIndex
      let vm = this
      let input = []
      input = temp.map((el, index) => {
        return { id: el.id, priority: index }
      })

      api.putprioritysubcategoriesKFC({ input, pageid: this.pageid }, function (error, response) {
        if (error) {
          console.error(error)
          vm.isLoading = false
          return
        }
      })

      vm.$emit('inputsub', vm.subcategoryList)
    },
    onEditCategory: function (index) {
      this.currentCategory = this.categorylist[index]
      this.showEdit = true
    },
    onSelectCategory: function (index) {
      this.currentCategory = this.categorylist[index]
    },
    // pressAddEnter: function(e) {
    //   if (e.keyCode === 13) {
    //     this.onAddCategory()
    //   }
    // },
    onCancelAddCategory: function () {
      var vm = this
      vm.newCategory.name = ''
      vm.isAdd = false
    },
    onCancelAddSubCategory: function () {
      var vm = this
      vm.newSubCategory.name = ''
      vm.isAddSub = false
    },
    onAddCategory: function () {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.newCategory.name == null || vm.newCategory.name.trim() == '') {
          vm.newCategory.name = ''
          vm.isAdd = false
          return false
        }
        vm.newCategory.name = (vm.prefix ? vm.prefix + '/' : '') + vm.newCategory.name
        let data = {
          pageid: vm.pageid,
          name: vm.newCategory.name
        }
        vm.isLoading = true
        api.saveCategory(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }

          vm.newCategory.id = response.categoryid
          vm.newCategory.subcategories = []

          vm.categorylist.push(vm.newCategory)
          vm.newCategory = { name: null }
          vm.isAdd = false
          vm.isLoading = false
          vm.$emit('input', vm.categorylist)
          vm.$emit('onCategoryChange')
        })
      })
    },
    onAddCategory: function () {
      let vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.newSubCategory.name == null || vm.newSubCategory.name.trim() == '') {
          vm.newSubCategory.name = ''
          vm.isAdd = false
          return false
        }
        vm.newSubCategory.name = (vm.prefix ? vm.prefix + '/' : '') + vm.newSubCategory.name
        let data = {
          pageid: vm.pageid,
          name: vm.newSubCategory.name
        }
        vm.isLoading = true
        api.saveSubCategory(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }

          vm.newSubCategory.id = response.categoryid
          vm.newSubCategory.subcategories = []

          vm.categorylist.push(vm.newSubCategory)
          vm.newSubCategory = { name: null }
          vm.isAddSub = false
          vm.isLoading = false
          vm.$emit('input', vm.categorylist)
          vm.$emit('onCategoryChange')
        })
      })
    },
    onDeleteCategory: function (index, payload) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.categorylist[index].name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          focusConfirm: true
        })
        .then((result) => {
          if (result.value) {
            api.deleteCategory(payload, function (error, response) {
              if (error) {
                console.error(error)
                return
              }

              vm.categorylist.splice(index, 1)
              vm.$emit('input', vm.categorylist)
              vm.$emit('onCategoryChange')
              vm.$emit('deleteCategory', payload)
            })
          }
        })
    },
    onAddSubCategory: function () {
      let vm = this
      let data = {
        pageid: vm.pageid,
        name: vm.newSubCategory.name,
        categoryid: vm.currentCategory.id
      }
      api.saveSubCategory(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        vm.newSubCategory.id = response.subcategoryid

        let categoryIndex = vm.categorylist.findIndex((category) => {
          return category.id == vm.currentCategory.id
        })
        vm.categorylist[categoryIndex].subcategories.push(vm.newSubCategory)
        vm.newSubCategory = { name: null }
      })
    },
    onEditSubCategory: function (index) {
      this.currentSubCategory = this.currentCategory.subcategories[index]
    },
    onDeleteSubCategory: function (index, id) {
      if (confirm('Do you want to delete this?')) {
        let vm = this
        api.deleteSubCategory(id, function (error, response) {
          if (error) {
            console.error(error)
            return
          }

          vm.currentCategory.subcategories.splice(index, 1)
        })
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.categorylist = newVal
    }
  }
}
</script>

<style>
.list-category-group {
  text-decoration: none;
  list-style-type: none;
  padding-left: 0px;
}

.list-category:first-child {
  border-top: 1px solid #eee;
}

.list-category {
  padding: 10px;

  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.list-category.active {
  background-color: #007bff;
  color: white;
}

.grab {
  cursor: -webkit-grab;
  cursor: grab;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/CategoriesKfc.vue